import type { Cookie } from 'src/cookies';
import { getCookieWithKey } from 'src/cookies';

export const necessaryConsentCookieCategoryKey = 'necessary';

export const getNecessaryCookieWithKey = (key: string): Cookie =>
  getCookieWithKey(key, necessaryConsentCookieCategoryKey);
